'use client';
import { 
    useContext, 
    useEffect,
    useState
} from 'react'
import { motion } from "framer-motion"
import Link from 'next/link';
import s from './Oops.module.scss';
import { PortableText } from '@portabletext/react';
import { portableBlockComponents } from '@/utils/portableText';
import CtaButton from '../CtaButton';


export default function OopsComponent({data}: any){

    // Fallback si el singleton de settings no tiene notFoundPage configurado
    const page = data?.notFoundPage ?? null;

    return (
        <>
        { 
            
            <motion.div
                className={s.oops}
                transition={{
                    duration: 0.8,
                    delay: 0,
                    ease: [0, 0.71, 0.2, 1.01]
                }}
                id={`oops-slide`}
                >
                    <header className={s.header}>
                        {/* <a className={s.close} onClick={()=>{ setCartOpen(false) }}>Cerrar</a> */}
                        <h3>{page?.title || "Oops — page not found"}</h3>
                    </header>
                    <main className={s.main}>
                    {page?.body &&
                    <div className={s.empty}>
                        <PortableText
                            value={page.body}
                            components={portableBlockComponents(page.body)}
                        />
                    </div>
                }
                    </main>
                    <footer className={s.footer}>
                        <div className={s.gridElContinue}>
                            {page?.link?.title ?
                                <CtaButton data={page.link} icon={null}/>
                                : <Link href="/">BACK TO HOME</Link>
                            }
                        </div>
                    </footer>
                </motion.div>

        }
        </>
    )
}

